<progress class="z-hidden-progress" [value]="value" [max]="max"></progress>

<svg class="z-svg" height="100%" width="100%" aria-hidden="true">
  <circle class="z-track" [attr.r]="oldEdgeRadiusFallback" cx="50%" cy="50%"></circle>

  <circle class="z-progress" #progressCircle [attr.r]="oldEdgeRadiusFallback" cx="50%" cy="50%"></circle>
</svg>
